module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Postzegel post"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Weeg de bestelling en selecteer het gewicht van de bestelling "), _c('br'), _vm._v(" LET OP: Klikken is betalen! ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row gutters-tiny"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(null)
      }
    }
  }, [_vm._v("\n                Ongefrankeerd\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(10)
      }
    }
  }, [_vm._v("\n                0-20 gram\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(40)
      }
    }
  }, [_vm._v("\n                20-50 gram\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('postage-stamp-type', {
    attrs: {
      "icon": "envelope"
    },
    on: {
      "click": function($event) {
        _vm.createShipment(75)
      }
    }
  }, [_vm._v("\n                50-100 gram\n              ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57093d78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/orders/PostageStampDetailModal.vue
// module id = 719
// module chunks = 1